export default __webpack_public_path__ + "static/bg-business-dilemma-47265f8359315bce780cfb973ee2be7f.webp";